// store/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const InvestmentSlice = createSlice({
  name: "investment",
  initialState: {
    investmentId:localStorage.getItem("investmentId") || null,
  },
  reducers: {
    setInvestmentId: (state, action) => {
      localStorage.setItem("investmentId", action.payload);
      state.investmentId = action.payload;
    },
    clearInvestmentId: (state) => {
      localStorage.removeItem("investmentId");
      state.investmentId = null;
    },
  },
});

export const { setInvestmentId, clearInvestmentId } = InvestmentSlice.actions;
export default InvestmentSlice.reducer;
